// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/tenancy.proto

/* eslint-disable */

export const protobufPackage = "models";

/** The result of the most recent action_taken */
export enum ActionResult {
  ACTION_RESULT_UNSPECIFIED = 0,
  /** RESULT_NA - No action was taken */
  RESULT_NA = 1,
  /** DRY_RUN - Handler was not commit-eligible and not notify-eligible */
  DRY_RUN = 2,
  /** COMMITTED - Database changes were committed but no notification was sent */
  COMMITTED = 3,
  /** NOTIFIED - Notification was sent but no database changes were committed */
  NOTIFIED = 4,
  /** COMMITTED_AND_NOTIFIED - Both database changes and a notification occurred */
  COMMITTED_AND_NOTIFIED = 5,
  UNRECOGNIZED = -1,
}

export function actionResultFromJSON(object: any): ActionResult {
  switch (object) {
    case 0:
    case "ACTION_RESULT_UNSPECIFIED":
      return ActionResult.ACTION_RESULT_UNSPECIFIED;
    case 1:
    case "RESULT_NA":
      return ActionResult.RESULT_NA;
    case 2:
    case "DRY_RUN":
      return ActionResult.DRY_RUN;
    case 3:
    case "COMMITTED":
      return ActionResult.COMMITTED;
    case 4:
    case "NOTIFIED":
      return ActionResult.NOTIFIED;
    case 5:
    case "COMMITTED_AND_NOTIFIED":
      return ActionResult.COMMITTED_AND_NOTIFIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ActionResult.UNRECOGNIZED;
  }
}

export function actionResultToJSON(object: ActionResult): string {
  switch (object) {
    case ActionResult.ACTION_RESULT_UNSPECIFIED:
      return "ACTION_RESULT_UNSPECIFIED";
    case ActionResult.RESULT_NA:
      return "RESULT_NA";
    case ActionResult.DRY_RUN:
      return "DRY_RUN";
    case ActionResult.COMMITTED:
      return "COMMITTED";
    case ActionResult.NOTIFIED:
      return "NOTIFIED";
    case ActionResult.COMMITTED_AND_NOTIFIED:
      return "COMMITTED_AND_NOTIFIED";
    case ActionResult.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** The action a handler took for an org in its most recent run */
export enum ActionTaken {
  ACTION_TAKEN_UNSPECIFIED = 0,
  /** ACTION_NA - Handler is not applicable to this org */
  ACTION_NA = 1,
  /**
   * NO_ACTION - Handler is applicable to this org but no action was needed
   * this run
   */
  NO_ACTION = 2,
  /** DISABLED_ORG - Marked the org Disabled */
  DISABLED_ORG = 3,
  /** DELETED_ORG - Marked the org Deleted */
  DELETED_ORG = 4,
  /** PURGED_ORG - Removed all remaining handler state for a purged org */
  PURGED_ORG = 5,
  /** WARNED_ORG - Sent a warning notification to org admin */
  WARNED_ORG = 6,
  /** CLEANED_UP - Performed handler-specific cleanup. See audit_trail for details. */
  CLEANED_UP = 7,
  UNRECOGNIZED = -1,
}

export function actionTakenFromJSON(object: any): ActionTaken {
  switch (object) {
    case 0:
    case "ACTION_TAKEN_UNSPECIFIED":
      return ActionTaken.ACTION_TAKEN_UNSPECIFIED;
    case 1:
    case "ACTION_NA":
      return ActionTaken.ACTION_NA;
    case 2:
    case "NO_ACTION":
      return ActionTaken.NO_ACTION;
    case 3:
    case "DISABLED_ORG":
      return ActionTaken.DISABLED_ORG;
    case 4:
    case "DELETED_ORG":
      return ActionTaken.DELETED_ORG;
    case 5:
    case "PURGED_ORG":
      return ActionTaken.PURGED_ORG;
    case 6:
    case "WARNED_ORG":
      return ActionTaken.WARNED_ORG;
    case 7:
    case "CLEANED_UP":
      return ActionTaken.CLEANED_UP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ActionTaken.UNRECOGNIZED;
  }
}

export function actionTakenToJSON(object: ActionTaken): string {
  switch (object) {
    case ActionTaken.ACTION_TAKEN_UNSPECIFIED:
      return "ACTION_TAKEN_UNSPECIFIED";
    case ActionTaken.ACTION_NA:
      return "ACTION_NA";
    case ActionTaken.NO_ACTION:
      return "NO_ACTION";
    case ActionTaken.DISABLED_ORG:
      return "DISABLED_ORG";
    case ActionTaken.DELETED_ORG:
      return "DELETED_ORG";
    case ActionTaken.PURGED_ORG:
      return "PURGED_ORG";
    case ActionTaken.WARNED_ORG:
      return "WARNED_ORG";
    case ActionTaken.CLEANED_UP:
      return "CLEANED_UP";
    case ActionTaken.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** CredentialsType defines an enumeration for various authentication credentials. */
export enum CredentialsType {
  /** CREDENTIALS_UNSPECIFIED - Unknown credential type */
  CREDENTIALS_UNSPECIFIED = 0,
  /** PASSWORD - Username/Password based credential */
  PASSWORD = 1,
  /** PUBLIC_KEY - SSH private/public key authentication */
  PUBLIC_KEY = 2,
  UNRECOGNIZED = -1,
}

export function credentialsTypeFromJSON(object: any): CredentialsType {
  switch (object) {
    case 0:
    case "CREDENTIALS_UNSPECIFIED":
      return CredentialsType.CREDENTIALS_UNSPECIFIED;
    case 1:
    case "PASSWORD":
      return CredentialsType.PASSWORD;
    case 2:
    case "PUBLIC_KEY":
      return CredentialsType.PUBLIC_KEY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CredentialsType.UNRECOGNIZED;
  }
}

export function credentialsTypeToJSON(object: CredentialsType): string {
  switch (object) {
    case CredentialsType.CREDENTIALS_UNSPECIFIED:
      return "CREDENTIALS_UNSPECIFIED";
    case CredentialsType.PASSWORD:
      return "PASSWORD";
    case CredentialsType.PUBLIC_KEY:
      return "PUBLIC_KEY";
    case CredentialsType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Eligibility of a handler for an org */
export enum Eligible {
  ELIGIBLE_UNSPECIFIED = 0,
  /** ELIGIBILITY_INHERIT - Defer to a less-specific context. Default for all columns */
  ELIGIBILITY_INHERIT = 1,
  /** ELIGIBILITY_NO - Not eligible. Overrides less-specific values except NEVER and ALWAYS. */
  ELIGIBILITY_NO = 2,
  /** ELIGIBILITY_YES - Eligible. Overrides less-specific values except NEVER and ALWAYS. */
  ELIGIBILITY_YES = 3,
  /** ELIGIBILITY_NEVER - Never eligible. Overrides less-specific values except ALWAYS. */
  ELIGIBILITY_NEVER = 4,
  /** ELIGIBILITY_ALWAYS - Always eligible. Overrides less-specific values except NEVER. */
  ELIGIBILITY_ALWAYS = 5,
  UNRECOGNIZED = -1,
}

export function eligibleFromJSON(object: any): Eligible {
  switch (object) {
    case 0:
    case "ELIGIBLE_UNSPECIFIED":
      return Eligible.ELIGIBLE_UNSPECIFIED;
    case 1:
    case "ELIGIBILITY_INHERIT":
      return Eligible.ELIGIBILITY_INHERIT;
    case 2:
    case "ELIGIBILITY_NO":
      return Eligible.ELIGIBILITY_NO;
    case 3:
    case "ELIGIBILITY_YES":
      return Eligible.ELIGIBILITY_YES;
    case 4:
    case "ELIGIBILITY_NEVER":
      return Eligible.ELIGIBILITY_NEVER;
    case 5:
    case "ELIGIBILITY_ALWAYS":
      return Eligible.ELIGIBILITY_ALWAYS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Eligible.UNRECOGNIZED;
  }
}

export function eligibleToJSON(object: Eligible): string {
  switch (object) {
    case Eligible.ELIGIBLE_UNSPECIFIED:
      return "ELIGIBLE_UNSPECIFIED";
    case Eligible.ELIGIBILITY_INHERIT:
      return "ELIGIBILITY_INHERIT";
    case Eligible.ELIGIBILITY_NO:
      return "ELIGIBILITY_NO";
    case Eligible.ELIGIBILITY_YES:
      return "ELIGIBILITY_YES";
    case Eligible.ELIGIBILITY_NEVER:
      return "ELIGIBILITY_NEVER";
    case Eligible.ELIGIBILITY_ALWAYS:
      return "ELIGIBILITY_ALWAYS";
    case Eligible.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Enumeration of brig lifecycle handlers */
export enum Handler {
  HANDLER_UNSPECIFIED = 0,
  /** ALL_HANDLERS - Sentinel name used with the all-orgs row to specify defaults for every handler. */
  ALL_HANDLERS = 1,
  /** HANDLER_DISABLE_ORG - Marks an org Disabled after a set of conditions are met */
  HANDLER_DISABLE_ORG = 2,
  /**
   * HANDLER_DELETE_ORG - Marks a Disabled org Deleted after a grace period during
   * which an admin may reactivate it
   */
  HANDLER_DELETE_ORG = 3,
  /** HANDLER_PURGE_ORG - Purges a Deleted org and deletes all of its config objects */
  HANDLER_PURGE_ORG = 4,
  UNRECOGNIZED = -1,
}

export function handlerFromJSON(object: any): Handler {
  switch (object) {
    case 0:
    case "HANDLER_UNSPECIFIED":
      return Handler.HANDLER_UNSPECIFIED;
    case 1:
    case "ALL_HANDLERS":
      return Handler.ALL_HANDLERS;
    case 2:
    case "HANDLER_DISABLE_ORG":
      return Handler.HANDLER_DISABLE_ORG;
    case 3:
    case "HANDLER_DELETE_ORG":
      return Handler.HANDLER_DELETE_ORG;
    case 4:
    case "HANDLER_PURGE_ORG":
      return Handler.HANDLER_PURGE_ORG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Handler.UNRECOGNIZED;
  }
}

export function handlerToJSON(object: Handler): string {
  switch (object) {
    case Handler.HANDLER_UNSPECIFIED:
      return "HANDLER_UNSPECIFIED";
    case Handler.ALL_HANDLERS:
      return "ALL_HANDLERS";
    case Handler.HANDLER_DISABLE_ORG:
      return "HANDLER_DISABLE_ORG";
    case Handler.HANDLER_DELETE_ORG:
      return "HANDLER_DELETE_ORG";
    case Handler.HANDLER_PURGE_ORG:
      return "HANDLER_PURGE_ORG";
    case Handler.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** OrgType defines an enumeration for various tenancies. */
export enum OrgType {
  ORG_TYPE_UNSPECIFIED = 0,
  SERVICE_PROVIDER = 1,
  ENTERPRISE = 2,
  SMALL_MEDIUM_BUSINESS = 3,
  CLOUD_CONSUMER = 4,
  UNRECOGNIZED = -1,
}

export function orgTypeFromJSON(object: any): OrgType {
  switch (object) {
    case 0:
    case "ORG_TYPE_UNSPECIFIED":
      return OrgType.ORG_TYPE_UNSPECIFIED;
    case 1:
    case "SERVICE_PROVIDER":
      return OrgType.SERVICE_PROVIDER;
    case 2:
    case "ENTERPRISE":
      return OrgType.ENTERPRISE;
    case 3:
    case "SMALL_MEDIUM_BUSINESS":
      return OrgType.SMALL_MEDIUM_BUSINESS;
    case 4:
    case "CLOUD_CONSUMER":
      return OrgType.CLOUD_CONSUMER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrgType.UNRECOGNIZED;
  }
}

export function orgTypeToJSON(object: OrgType): string {
  switch (object) {
    case OrgType.ORG_TYPE_UNSPECIFIED:
      return "ORG_TYPE_UNSPECIFIED";
    case OrgType.SERVICE_PROVIDER:
      return "SERVICE_PROVIDER";
    case OrgType.ENTERPRISE:
      return "ENTERPRISE";
    case OrgType.SMALL_MEDIUM_BUSINESS:
      return "SMALL_MEDIUM_BUSINESS";
    case OrgType.CLOUD_CONSUMER:
      return "CLOUD_CONSUMER";
    case OrgType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** SupportAccessState defines whether support access is enabled for an organization. */
export enum SupportAccessState {
  /** SUPPORT_ACCESS_STATE_UNSPECIFIED - Default unspecified state. */
  SUPPORT_ACCESS_STATE_UNSPECIFIED = 0,
  /** OFF - Support access disabled. */
  OFF = 1,
  /** ON - Support access enabled. */
  ON = 2,
  UNRECOGNIZED = -1,
}

export function supportAccessStateFromJSON(object: any): SupportAccessState {
  switch (object) {
    case 0:
    case "SUPPORT_ACCESS_STATE_UNSPECIFIED":
      return SupportAccessState.SUPPORT_ACCESS_STATE_UNSPECIFIED;
    case 1:
    case "OFF":
      return SupportAccessState.OFF;
    case 2:
    case "ON":
      return SupportAccessState.ON;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SupportAccessState.UNRECOGNIZED;
  }
}

export function supportAccessStateToJSON(object: SupportAccessState): string {
  switch (object) {
    case SupportAccessState.SUPPORT_ACCESS_STATE_UNSPECIFIED:
      return "SUPPORT_ACCESS_STATE_UNSPECIFIED";
    case SupportAccessState.OFF:
      return "OFF";
    case SupportAccessState.ON:
      return "ON";
    case SupportAccessState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
